import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import Logo from '../../components/Logo';
import AdminUsersTab from './tabs/AdminUsersTab';
import AdminPlansTab from './tabs/AdminPlansTab';
import AdminOrdersTab from './tabs/AdminOrdersTab';
import AdminStatsTab from './tabs/AdminStatsTab';

const TABS = [
  { key: 'stats',  label: 'Stats' },
  { key: 'users',  label: 'Users' },
  { key: 'plans',  label: 'Plans' },
  { key: 'orders', label: 'Orders' },
];

const AdminDashboard = () => {
  const { admin, logout } = useAdminAuth();
  const navigate = useNavigate();
  const [active, setActive] = useState('stats');
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/admin/login');
  };

  const selectTab = (key) => {
    setActive(key);
    setMenuOpen(false);
  };

  return (
    <div className="admin-shell">
      <header className="admin-header">
        <div className="admin-header-left">
          <button
            className="admin-burger"
            onClick={() => setMenuOpen(true)}
            aria-label="Open menu"
          >
            <Menu size={20} />
          </button>
          <div className="admin-brand">
            <Logo height={28} />
            <span className="admin-brand-sep"> · Admin</span>
          </div>
        </div>
        <div className="admin-header-right">
          <span className="admin-who">{admin?.email}</span>
          <button onClick={handleLogout} className="admin-logout-btn">Sign out</button>
        </div>
      </header>

      <nav className="admin-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            className={active === t.key ? 'admin-tab active' : 'admin-tab'}
            onClick={() => setActive(t.key)}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {menuOpen && (
        <div className="admin-overlay" onClick={() => setMenuOpen(false)} />
      )}

      <div className={`admin-drawer${menuOpen ? ' open' : ''}`}>
        <div className="admin-drawer-top">
          <div className="admin-brand">
            <Logo height={28} />
          </div>
          <button
            className="admin-drawer-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <X size={20} />
          </button>
        </div>
        <nav className="admin-drawer-nav">
          {TABS.map((t) => (
            <button
              key={t.key}
              className={`admin-drawer-item${active === t.key ? ' active' : ''}`}
              onClick={() => selectTab(t.key)}
            >
              {t.label}
            </button>
          ))}
        </nav>
        <div className="admin-drawer-footer">
          <span className="admin-who">{admin?.email}</span>
          <button onClick={handleLogout} className="admin-logout-btn">Sign out</button>
        </div>
      </div>

      <main className="admin-main">
        {active === 'stats'  && <AdminStatsTab />}
        {active === 'users'  && <AdminUsersTab />}
        {active === 'plans'  && <AdminPlansTab />}
        {active === 'orders' && <AdminOrdersTab />}
      </main>
    </div>
  );
};

export default AdminDashboard;
